import { atom, useAtom } from 'jotai';

const SubAccountErrorDialogAtom = atom<string[]>([]);

export const useSubAccountErrorDialog = () => {
  const [idSubAccountErrorDialogOpen, setSubAccountErrorDialogOpen] =
    useAtom(SubAccountErrorDialogAtom);

  return {
    idSubAccountErrorDialogOpen,
    setSubAccountErrorDialogOpen,
  };
};
